<template>
  <v-app-bar app clipped-left dense color="blue darken-3" dark>
    <v-toolbar-title>
      <v-btn text to="/">Bicom Systems</v-btn>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <span> {{ username }} </span>
    <v-menu transition="slide-y-transition" bottom :offset-y="true">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>fa fa-user</v-icon>
        </v-btn>
      </template>
      <v-list class="fs-16" dense>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>{{ "mwp-18 fs-16 fa fa-user align-flex" }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ "Profile" }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item @click="logout()" class="cursor-pointer">
          <v-list-item-icon>
            <v-icon :color="'red darken-1'">{{
              "mwp-18 fs-16 fa fa-power-off align-flex"
            }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ "Logout" }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import * as AC from "../../store/action-types";
export default {
  name: "PageHeader",
  data() {
    return {
      username: "",
    };
  },
  methods: {
    logout() {
      this.$store.dispatch(AC.AUTH_DO_LOGOUT);
      this.$forceUpdate();
    },
  },
  mounted() {
    if ( this.$store.state.user) {
        this.username =  this.$store.state.user.UserName;
    }
  },
};
</script>
<style scoped>
.mwp-18 {
  max-width: 18px;
}
.fs-16 {
  font-size: 16px !important;
}
.align-flex {
  align-items: flex-end;
}

.v-list-item__icon {
  margin-right: 10px !important;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
